import baseStore from '../generic_store';

const base = baseStore('domains');

const state = {
    ...base.state,
    base_url: '/api/domains',
    resourceName: 'Domain',
    model: {
        translatable: {
            name: {
                fr: '',
                en: ''
            },
            title: {
                fr: '',
                en: '',
            },
            subtitle: {
                fr: '',
                en: '',
            }
        },
        name: {
            fr: '',
            en: ''
        },
        title: {
            fr: '',
            en: '',
        },
        subtitle: {
            fr: '',
            en: '',
        }
    },
};

const getters = {
    ...base.getters,
};

const actions = {
    ...base.actions,
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

